import './menstrualeducation.css'

import { Link } from 'react-router-dom'
import urlImgLibro from '../../../../assets/img/libro/libro_img.png'
import indicePdf from '../../../../assets/files/indice.pdf'

const MenstrualEducation = () => {
  return (
    <section className="menstrualEducation section__padding">
      
      {/* COLUMNA IZQUIERDA */}
      <div className="menstrualEducation__imageColumn">
        <img
          src={urlImgLibro}
          alt="Libro Educación Menstrual"
          className="menstrualEducation__book"
        />

        <a
          href="https://traficantes.net/libros/educaci%C3%B3n-menstrual"
          target="_blank"
          rel="noopener noreferrer"
          className="menstrualEducation__button"
        >
          Comprar libro
        </a>
      </div>

      {/* COLUMNA DERECHA */}
      <div className="menstrualEducation__content">
        <div className="menstrualEducation__heading">
          <h3 className="menstrualEducation__title">Educación menstrual</h3>

          <p className="menstrualEducation__subtitle">
            Un libro colectivo desde el sentipensar, la experiencia y la
            investigación científica, en clave feminista, interseccional e
            internacional.
          </p>
        </div>

        <div className="menstrualEducation__block">
          <h4>Datos del libro</h4>
          <p><strong>ISBN:</strong> 978-84-124417-7-2</p>
          <p><strong>Precio base:</strong> 13,00 €</p>
          <p><strong>Publicación:</strong> enero de 2026</p>
          <p><strong>Páginas:</strong> 144 (incluye 4 de fotografías)</p>
          <p><strong>Medidas:</strong> 230 × 155 mm</p>
          <p><strong>Coordinadora:</strong> Carolina Ackermann Barreiro</p>
          <p><strong>Coedición:</strong> La Vida en Rojo, Asociación de cultura menstrual y Sueños de Sabotaje-TdS</p>
          <p><strong>Autoras:</strong> Trabajo colectivo de 14 mujeres, con revisión y aporte conjunto en todo el libro</p>
          <p><strong>Portada:</strong> ilustración de Rocío Remuiñán Ackermann</p>
        </div>

        <div className="menstrualEducation__block">
          <h4>Dónde conseguirlo</h4>
          <ul>
            <li>Disponible en librerías online.</li>
            <li>En tu librería de barrio habitual</li>
            <li>En tu biblioteca mediante una desiderata</li>
          </ul>
          <a
            href={indicePdf}
            download
            className="menstrualEducation__button menstrualEducation__button--download"
          >
            Descargar índice
          </a>
        </div>

        <div className="menstrualEducation__block menstrualEducation__block--en">
          <h4>About the book</h4>
          <p className="menstrualEducation__enSubtitle">Menstrual Education</p>
          <Link to="/libro-en" className="menstrualEducation__enLink">
            Read the book description in English →
          </Link>
        </div>
      </div>
    </section>
  )
}

export default MenstrualEducation
